export const SEARCH_VIEW = {
  Grid: 'grid',
  List: 'list',
} as const;
